export enum RegistrationType {
  NewCustomer = 1,
  ExistingCustomer,
  AdminCustomer,
}
